// Logic from this module was moved into core since approx. 7.27
// TODO: remove this in v8
